module.exports = __webpack_public_path__ + "static/media/trash.ac97b455.svg";